import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { MobileBlocker } from '../../../components/mobile-blocker';
import { trackError } from '../../../error/tracking';
import { captureException } from '../../../logger/capture-exception';
import { getQueryClient } from '../../../sdk/request';
import { fetchBulkGroupsByBrandIdImperative } from '../../../services/storage';
import { prefetchProductTemplatesByBrandId } from '../../../services/storage/product-template-queries';
import { getAuthUserFromCache } from '../../../services/storage/users-queries';
import { getSelectedBrand } from '../../../shared/brand';
import { Feature, isFeatureAvailable } from '../../../shared/feature';
import { HeaderProducts } from './components/-header-products';
import { TemplateListing } from './components/-template-listing';

export const Route = createFileRoute('/app/_sidebar-layout/products/templates')({
  beforeLoad: function () {
    // Get user from TanStack Query cache (populated during auth initialization)
    const queryClient = getQueryClient();
    const currentUser = getAuthUserFromCache(queryClient);
    const currentBrand = getSelectedBrand(currentUser);
    if (currentBrand?._id == null) {
      // user shouldn't access this page without a current org,
      // make him refresh his page
      window.location.href = '/app';
      return;
    }
    return Promise.allSettled([
      prefetchProductTemplatesByBrandId(currentBrand._id),
      fetchBulkGroupsByBrandIdImperative(queryClient, currentBrand._id),
    ]).catch(function (err) {
      captureException(
        err,
        {
          file: 'app/_sidebar-layout.products/templates.tsx',
          method: 'beforeLoad',
          infoMessage: 'unable to fetch data from api',
        },
        trackError
      );

      throw err;
    });
  },
  // eslint-disable-next-line no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  // TanStack Query hook for auth user
  const queryClient = getQueryClient();
  const currentUser = getAuthUserFromCache(queryClient);
  const navigate = useNavigate();
  useEffect(
    function () {
      if (!isFeatureAvailable(Feature.PRODUCT)) {
        navigate({ to: '/app/blogs' }).catch(function (err) {
          captureException(
            err,
            {
              file: 'src/routes/app/_sidebar-layout.products/templates.tsx',
              method: 'navigate',
              infoMessage: 'unable to navigate to /app/blogs',
            },
            trackError
          );
        });
      }
    },
    [navigate]
  );
  return (
    <>
      <MobileBlocker />
      <div className="h-full w-full flex-1 overflow-y-auto">
        <div className="mx-auto flex h-full w-full max-w-content flex-col items-start">
          <HeaderProducts currentUser={currentUser} />
          <TemplateListing />
        </div>
      </div>
    </>
  );
}
